import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { LoginUser } from '../models/login-user';
import { ApiResponse } from '../models/api-response';
import { UserMenuNodes } from '../models/user-menu-nodes';

import { AppConfigService } from '../app-config.service.service';
import { BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  private uri = `${environment.apiUrl}`;
  public currentUserName = new BehaviorSubject<string>('');
  public isClient = new BehaviorSubject<boolean>(false);
  // public settings: BehaviorSubject() = {
    // dateFormat: '',
    // moneyFormat: '',
    // startPage: ''
  // }

  public settings = new BehaviorSubject<any>({
    dateFormat: '',
    moneyFormat: '',
    startPage: '',
    map: '',
    regionid: '',
    languageid: ''
  })

  constructor(private http: HttpClient, private appConfigService: AppConfigService, private router: Router) {

  }
  login(loginUser: LoginUser) {
    this.uri = this.appConfigService.apiBaseUrl;
    return this.http.post<ApiResponse>(this.uri + '/user', loginUser);
  }
  autologin(email: string) {
    this.uri = this.appConfigService.apiBaseUrl;
    return this.http.post<ApiResponse>(this.uri + '/user', { username: email, password: '', remember: '' } );
  }
  getMenu() {
    this.uri = this.appConfigService.apiBaseUrl;
    return this.http.post<UserMenuNodes[]>(this.uri + '/UserMenu', {});
  }

  changePassword(pass) {
    this.uri = this.appConfigService.apiBaseUrl;
    let email = localStorage.getItem('email');
    return this.http.post<any>(this.uri + '/User/ChangePassword', {
      user: email,
      password: pass
    });
  }

  changePasswordCW(pass) {
    this.uri = this.appConfigService.apiBaseUrl;
    let email = localStorage.getItem('email');
    return this.http.post<any>(this.uri + '/User/ChangePasswordCW', {
      Email: email,
      Password: pass
    });
  }

  getZDUserToken() {
    this.uri = this.appConfigService.apiBaseUrl;
    return this.http.post<any>(this.uri + '/User/GetZendDeskToken', {});
  }

  getClientTypes() {
    this.uri = this.appConfigService.apiBaseUrl;
    return this.http.post<any>(this.uri + '/User/GetClientTypes', {});
  }

  createDatabase(clientDatabase: string, clientID: number) {
    this.uri = this.appConfigService.apiBaseUrl;
    return this.http.post<any>(this.uri + '/User/CreateDatabase', { clientdatabase: clientDatabase, clientid: clientID });
  }

  recoverPassword(email) {
    this.uri = this.appConfigService.apiBaseUrl;
    return this.http.post<any>(this.uri + '/User/RecoverPassword', {
      Email: email
    });
  }

  recoverPasswordCW(email) {
    this.uri = this.appConfigService.apiBaseUrl;
    return this.http.post<any>(this.uri + '/User/RecoverPasswordCW', {
      Email: email
    });
  }

  saveUserSettingCoor(userSetting: any) {
    this.uri = this.appConfigService.apiBaseUrl;
    userSetting.method = "update_UserSettingsCoor";
    let user = JSON.parse(userSetting.usersettings)
    if(user && user.regionid){
      userSetting.regionid = user.regionid;
    }
    console.log(userSetting);
    return this.http.post<any>(this.uri + '/FlexIntegration/CallExtFlex', userSetting);
  }

  Get_ClientUserStartPagesCE() {
    this.uri = this.appConfigService.apiBaseUrl;
    return this.http.post<any>(this.uri + '/FlexIntegration/CallExtFlex', {
      method: 'Get_ClientUserStartPagesCE'
    });
  }

  Get_UserSettingsCE(userid) {
    this.uri = this.appConfigService.apiBaseUrl;
    return this.http.post<any>(this.uri + '/FlexIntegration/CallExtFlex', {
      method: 'Get_UserSettingsCE'
    });
  }

  Get_CubeShopLogin(user: any) {
    this.uri = this.appConfigService.apiBaseUrl;
    return this.http.post<any>(this.uri + '/user/Logincubecustomer', user);
  }

  GetUserClients() {
    this.uri = this.appConfigService.apiBaseUrl;
    return this.http.post<any>(this.uri + '/User/GetUserCompanies', {});
  }

  UpdateUserDefaultClient(dbid: number) {
    this.uri = this.appConfigService.apiBaseUrl;
    return this.http.post<any>(this.uri + '/User/updateDefaultCompany', { dbid: dbid });
  }

  activateUser(Email: string) {
    this.uri = this.appConfigService.apiBaseUrl;
    return this.http.post<any>(this.uri + '/User/ActivateUser', { Email: Email });
  }

  acceptTerms(Email: string) {
    this.uri = this.appConfigService.apiBaseUrl;
    return this.http.post<any>(this.uri + '/User/AccepTerm', { Email: Email });
  }

  getUserAvaliableGroups(userID: number) {
    this.uri = this.appConfigService.apiBaseUrl;
    return this.http.post<any>(this.uri + '/FlexIntegration/CallExtFlex', { method: "getUserAvaliableGroups", currentuserid: userID });
  }

  getUserAssignedGroups(userID: number) {
    this.uri = this.appConfigService.apiBaseUrl;
    return this.http.post<any>(this.uri + '/FlexIntegration/CallExtFlex', { method: "getUserAssignedGroups", currentuserid: userID });
  }

  getReportsAvaliableGroups(groupID: number) {
    this.uri = this.appConfigService.apiBaseUrl;
    return this.http.post<any>(this.uri + '/FlexIntegration/CallExtFlex', { method: "getGroupAvaliableReports", groupid: groupID });
  }

  getReportsAssignedGroups(groupID: number) {
    this.uri = this.appConfigService.apiBaseUrl;
    return this.http.post<any>(this.uri + '/FlexIntegration/CallExtFlex', { method: "getGroupAssignedReports", groupid: groupID });
  }

  getDashboardsAvaliableGroups(groupID: number) {
    this.uri = this.appConfigService.apiBaseUrl;
    return this.http.post<any>(this.uri + '/FlexIntegration/CallExtFlex', { method: "getGroupAvaliableDashboard", groupid: groupID });
  }

  getDashboardsAssignedGroups(groupID: number) {
    this.uri = this.appConfigService.apiBaseUrl;
    return this.http.post<any>(this.uri + '/FlexIntegration/CallExtFlex', { method: "getGroupAssignedDashboard", groupid: groupID });
  }

  getGroupNav(GroupID: number) {
    this.uri = this.appConfigService.apiBaseUrl;
    console.log({ method: "Get_GroupToNavByGroupId", usergroupid: GroupID });
    return this.http.post<any>(this.uri + '/FlexIntegration/CallExtFlex', { method: "Get_GroupToNavByGroupId", usergroupid: GroupID });
  }

  changeUserNav(navIDs: string, groupid: number) {
    this.uri = this.appConfigService.apiBaseUrl;
    return this.http.post<any>(this.uri + '/FlexIntegration/CallExtFlex', { method: "changeUserNav", navids: navIDs, groupid: groupid });
  }

  getUsers() {
    this.uri = this.appConfigService.apiBaseUrl;
    return this.http.post<any>(this.uri + '/FlexIntegration/CallExtFlex', { method: "Get_AllUser" });
  }

  getGroups() {
    this.uri = this.appConfigService.apiBaseUrl;
    return this.http.post<any>(this.uri + '/FlexIntegration/CallExtFlex', { method: "Get_UserGroups" });
  }

  deleteUserToGroup(groupids: string, userid: number) {
    this.uri = this.appConfigService.apiBaseUrl;
    return this.http.post<any>(this.uri + '/FlexIntegration/CallExtFlex', { method: "deleteUserToGroup", userid: userid, groupids: groupids });
  }

  insertUserToGroup(groupids: string, userid: number) {
    this.uri = this.appConfigService.apiBaseUrl;
    return this.http.post<any>(this.uri + '/FlexIntegration/CallExtFlex', { method: "insertUserToGroup", currentuserid: userid, groupids: groupids });
  }

  async asyncInsertUserToGroup(groupids: string, userid: number) {
    this.uri = this.appConfigService.apiBaseUrl;
    return this.http.post<any>(this.uri + '/FlexIntegration/CallExtFlex', { method: "insertUserToGroup", currentuserid: userid, groupids: groupids });
  }

  async asyncDeleteUserToGroup(groupids: string, userid: number) {
    this.uri = this.appConfigService.apiBaseUrl;
    return this.http.post<any>(this.uri + '/FlexIntegration/CallExtFlex', { method: "deleteUserToGroup", userid: userid, groupids: groupids });
  }

  deleteReportToGroup(reportids: string, groupid: number) {
    this.uri = this.appConfigService.apiBaseUrl;
    return this.http.post<any>(this.uri + '/FlexIntegration/CallExtFlex', { method: "deleteGroupToReport", groupid: groupid, reportids: reportids });
  }

  insertReportToGroup(reportids: string, groupid: number) {
    this.uri = this.appConfigService.apiBaseUrl;
    return this.http.post<any>(this.uri + '/FlexIntegration/CallExtFlex', { method: "insertGroupToReport", groupid: groupid, reportids: reportids });
  }

  deleteDashboardToGroup(dashboardids: string, groupid: number) {
    this.uri = this.appConfigService.apiBaseUrl;
    return this.http.post<any>(this.uri + '/FlexIntegration/CallExtFlex', { method: "deleteGroupToDashboard", groupid: groupid, dashboardids: dashboardids });
  }

  insertDashboardToGroup(dashboardids: string, groupid: number) {
    this.uri = this.appConfigService.apiBaseUrl;
    return this.http.post<any>(this.uri + '/FlexIntegration/CallExtFlex', { method: "insertGroupToDashboard", groupid: groupid, dashboardids: dashboardids });
  }

  getUserInUserGroup(groupid: number) {
    this.uri = this.appConfigService.apiBaseUrl;
    return this.http.post<any>(this.uri + '/FlexIntegration/CallExtFlex', { method: "Get_UserInUserGroups", groupid: groupid });
  }

  createUser(email: string, password: string) {
    this.uri = this.appConfigService.apiBaseUrl;
    return this.http.post(this.uri + '/User/InsertUser', { "Email": email, "Password": password })
  }

  getEmployees() {
    this.uri = this.appConfigService.apiBaseUrl;
    return this.http.post<any>(this.uri + '/FlexIntegration/CallExtFlex', { method: "Get_EmployeeListAll" });
  }

  getGroupsAll() {
    this.uri = this.appConfigService.apiBaseUrl;
    return this.http.post<any>(this.uri + '/FlexIntegration/CallExtFlex', { method: "Get_UserGroups" });
  }

  insertGroup(id: string, groupname: string) {
    this.uri = this.appConfigService.apiBaseUrl;
    return this.http.post<any>(this.uri + '/FlexIntegration/CallExtFlex', { method: "InsertUpdate_UserGroups", id: id, groupname: groupname });
  }

  deleteGroup(id: string) {
    this.uri = this.appConfigService.apiBaseUrl;
    return this.http.post<any>(this.uri + '/FlexIntegration/CallExtFlex', { method: "Delete_UserGroups", id: id });
  }

  insertContact(contact: any) {
    this.uri = this.appConfigService.apiBaseUrl;
    return this.http.post<any>(this.uri + '/public/insertcontacce', contact );
  }

  insertCompany(company: any) {
    this.uri = this.appConfigService.apiBaseUrl;
    return this.http.post<any>(this.uri + '/public/InsertUser', company );
  }

  insertExtUsr(contact: any) {
    this.uri = this.appConfigService.apiBaseUrl;
    return this.http.post<any>(this.uri + '/User/createUsr', contact );
  }  

  insertClient(company: any) {
    this.uri = this.appConfigService.apiBaseUrl;
    return this.http.post<any>(this.uri + '/User/InsertClient', company );
  }

  getCustomers() {
    this.uri = this.appConfigService.apiBaseUrl;
    return this.http.post<any>(this.uri + '/FlexIntegration/CallExtFlex', { method: "Get_CustomerCE" });
  }

  createClientUser(email: string, userfirstname: string, userlastname: string, employeeid: number, isvendor: number, isclient: number, isemployee: number) {
    this.uri = this.appConfigService.apiBaseUrl;
    return this.http.post<any>(this.uri + '/FlexIntegration/CallExtFlex', { method: "InsertClientUser", email: email, userfirstname: userfirstname, userlastname: userlastname, employeeid: employeeid, isvendor: isvendor, isclient: isclient, isemployee: isemployee });
  }

  sendUserConfirm(email: string) {
    this.uri = this.appConfigService.apiBaseUrl;
    return this.http.post<any>(this.uri + '/User/SendUserConfirm', { Email: email } );
  }

  getUserAll() {
    this.uri = this.appConfigService.apiBaseUrl;
    return this.http.post<any>(this.uri + '/FlexIntegration/CallExtFlex', { method: "Get_UserAll" });
  }

  updateUserStatus(userID: number, userActive: number) {
    this.uri = this.appConfigService.apiBaseUrl;
    return this.http.post<any>(this.uri + '/FlexIntegration/CallExtFlex', { method: "updateUserStatus", luserid: userID, active: userActive });
  }

  updateUserStatusLock(userID: number, userActive: number) {
    this.uri = this.appConfigService.apiBaseUrl;
    return this.http.post<any>(this.uri + '/FlexIntegration/CallExtFlex', { method: "updateUserStatusLock", luserid: userID, active: userActive });
  }

}
